import React, { useState } from 'react';
import './App.css';

/* --- COMPONENTS --- */

const Navbar = ({ isOpen, setIsOpen }) => (
  <nav className="navbar">
    <div className="container nav-container">
      <div className="logo">COMFORT 13-47</div>
      <div className={`nav-links ${isOpen ? 'open' : ''}`}>
        <a href="#home" onClick={() => setIsOpen(false)}>Home</a>
        <a href="#promotions" onClick={() => setIsOpen(false)}>Promotions</a>
        <a href="#rooms" onClick={() => setIsOpen(false)}>Our Rooms</a>
        <a href="#booking" onClick={() => setIsOpen(false)}>Book Now</a>
        <a href="#contact" onClick={() => setIsOpen(false)}>Contact</a>
      </div>
      <button className="menu-btn" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? "Close" : "Menu"}
      </button>
    </div>
  </nav>
);

const Section = ({ id, title, children, className = "" }) => (
  <section id={id} className={`section ${className}`}>
    <div className="container">
      {title && <h2 className="section-title">{title}</h2>}
      {children}
    </div>
  </section>
);

/* --- MAIN APP --- */

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(null);

  const handleBooking = (e) => {
    e.preventDefault();
    setBookingStatus('searching');
    // Simulate a booking delay
    setTimeout(() => setBookingStatus('success'), 1500);
  };

  return (
    <div className="App">
      <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />

      {/* HERO */}
      <header id="home" className="hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Find Your Serenity</h1>
            <p>Experience luxury and comfort in the heart of the city at Comfort 13-47.</p>
            <a href="#booking" className="btn btn-primary">Check Availability</a>
          </div>
        </div>
      </header>

      {/* PROMOTIONS */}
      <Section id="promotions" title="Exclusive Offers">
        <div className="grid-3">
          {[
            { title: "Weekend Getaway", desc: "Get 20% off on Friday & Saturday stays.", img: "https://images.unsplash.com/photo-1540544660431-98411d9b7308?auto=format&fit=crop&w=800&q=80" },
            { title: "Business Class", desc: "Complimentary workspace & breakfast.", img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80" },
            { title: "Long Stay", desc: "Stay 7+ nights and save 30%.", img: "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?auto=format&fit=crop&w=800&q=80" }
          ].map((promo, i) => (
            <div key={i} className="card">
              <img src={promo.img} alt={promo.title} />
              <div className="card-body">
                <h3>{promo.title}</h3>
                <p>{promo.desc}</p>
                <span className="link-text">Learn More &rarr;</span>
              </div>
            </div>
          ))}
        </div>
      </Section>

      {/* ROOMS */}
      <Section id="rooms" title="Our Rooms" className="bg-gray">
        <div className="rooms-grid">
          {[
            { name: "The Standard", price: "$120", img: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=800&q=80" },
            { name: "Deluxe King", price: "$180", img: "https://images.unsplash.com/photo-1590490360182-f33fb0d41043?auto=format&fit=crop&w=800&q=80" },
            { name: "Presidential Suite", price: "$350", img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800&q=80" }
          ].map((room, i) => (
            <div key={i} className="room-card">
              <div className="room-img" style={{ backgroundImage: `url(${room.img})` }}>
                <div className="price-tag">{room.price}/night</div>
              </div>
              <div className="room-info">
                <h3>{room.name}</h3>
                <div className="amenities">
                  <span>📶 Wifi</span>
                  <span>📺 TV</span>
                  <span>☕ Breakfast</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Section>

      {/* BOOKING */}
      <Section id="booking" title="Reserve Your Stay">
        <div className="booking-container">
          <form className="booking-form" onSubmit={handleBooking}>
            <div className="input-group">
              <label>📅 Check In</label>
              <input type="date" required />
            </div>
            <div className="input-group">
              <label>📅 Check Out</label>
              <input type="date" required />
            </div>
            <div className="input-group">
              <label>👥 Guests</label>
              <select>
                <option>1 Guest</option>
                <option>2 Guests</option>
                <option>3 Guests</option>
                <option>4+ Guests</option>
              </select>
            </div>
            <button type="submit" className="btn btn-block">
              {bookingStatus === 'searching' ? 'Checking...' : bookingStatus === 'success' ? 'Available! Redirecting...' : 'Book Now'}
            </button>
          </form>
          {bookingStatus === 'success' && (
            <div className="success-message">
              <p>✅ Great news! We have rooms available for these dates.</p>
            </div>
          )}
        </div>
      </Section>

      {/* CONTACT */}
      <Section id="contact" title="Contact Us" className="bg-dark text-white">
        <div className="contact-layout">
          <div className="contact-info">
            <div className="contact-item">
              <div className="icon-gold">📍</div>
              <div>
                <h4>Location</h4>
                <p>13-47 Comfort Avenue, City Center, NY 10012</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="icon-gold">📞</div>
              <div>
                <h4>Phone</h4>
                <p>+1 (555) 123-4567</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="icon-gold">✉️</div>
              <div>
                <h4>Email</h4>
                <p>concierge@comfort1347.com</p>
              </div>
            </div>
          </div>
          <div className="map-placeholder">
            <p>Interactive Map Loading...</p>
          </div>
        </div>
      </Section>

      {/* FOOTER */}
      <footer>
        <p>&copy; {new Date().getFullYear()} Comfort 13-47 Hotel. All rights reserved.</p>
        <div className="socials">
          <span>Instagram</span>
          <span>Facebook</span>
          <span>Twitter</span>
        </div>
      </footer>
    </div>
  );
}

export default App;